import { render, staticRenderFns } from "./EUTaxNumber.vue?vue&type=template&id=30dd31fa&"
import script from "./EUTaxNumber.vue?vue&type=script&lang=js&"
export * from "./EUTaxNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports